import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as english } from '../../i18n/en';
import { locale as italian } from '../../i18n/it';
import { InvoiceService } from '../../invoice.service';

@Component({
  selector: 'app-publish-tos-dialog',
  templateUrl: './publish-tos-dialog.component.html',
  animations: fuseAnimations,
})
export class PublishTosDialogComponent implements OnInit {

  publishFormGroup: UntypedFormGroup;

  isPublishing = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: PublishTosDialogModel,
              private _dialogRef: MatDialogRef<PublishTosDialogComponent>,
              private _formBuilder: UntypedFormBuilder,
              private _invoiceService: InvoiceService,
              private _translationLoader: FuseTranslationLoaderService) {
    this._translationLoader.loadTranslations(italian, english);
  }

  ngOnInit(): void {
    this.publishFormGroup = this._formBuilder.group({
        'tos_1': new UntypedFormControl(false, Validators.pattern('true')),
        'tos_2': new UntypedFormControl(false, Validators.pattern('true')),
      },
      {
        updateOn: 'change',
      });
  }

  close(): void {
    this._dialogRef.close(false);
  }

  submit(): void {
    this.isPublishing = true;
    this.publishFormGroup.disable();
    this._invoiceService.publish(this.data.uuid)
      .subscribe(_ => {
        this._dialogRef.close(true);
      }, err => {
        this.isPublishing = false;
        throw err;
      });
  }

}

export interface PublishTosDialogModel {
  action: string;
  uuid: string;
}
